import React from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Grid,
    Typography
} from '@mui/material';
import reportslogo from "../../assets/images/reportslogo.png";
import moment from "moment";

const Licensedetails = ({ reportdata, service, level, licensecategory }) => {
    const currentyear = new Date().getFullYear(); // Get the current year

    return (
        <>

            <div>
                <div style={{ padding: '20px', marginTop: '20px' }}>
                    <TableContainer component={Paper} style={{ marginTop: '20px', overflow: "visible" }}>
                        <div>
                            <Grid container direction="row" justifyContent="space-between" alignItems="center" style={{ flexGrow: 1, marginBottom: '30px' }}>
                                {/* Logo Section */}
                                <Grid item style={{ marginRight: '20px' }}>
                                    <img src={reportslogo} alt="logo" style={{ maxWidth: '180px', height: '180px' }} />
                                </Grid>

                                {/* Text Section */}
                                <Grid item xs={12} md={8} style={{ textAlign: 'left', marginRight: '10px' }}>
                                    {/* Title */}
                                    <Typography variant="h6" style={{ margin: '0', fontSize: '30px', fontWeight: 'bold' }}>
                                        License Master List - Details
                                    </Typography>

                                    {/* Hospital and Service */}
                                    <Grid container justifyContent="center" style={{ marginTop: '20px' }}>
                                        <Grid item xs={12} md={12} style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
                                            {/* Hospital Master */}
                                            <Typography
                                                variant="subtitle1"
                                                style={{
                                                    fontSize: '18px',
                                                    fontWeight: 'bold',
                                                    marginRight: '20px', // Adjust space between label and value
                                                }}
                                            >
                                                Hospital Master :
                                            </Typography>
                                            <Typography
                                                variant="subtitle1"
                                                style={{
                                                    fontSize: '18px',
                                                    fontWeight: 'normal',
                                                }}
                                            >
                                                {level === 0
                                                    ? 'All'
                                                    : level === 1
                                                        ? localStorage.getItem('FacilityName')
                                                        : ''}
                                            </Typography>


                                        </Grid>

                                        <Grid item xs={12} md={12} style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
                                            {/* Service */}
                                            <Typography
                                                variant="subtitle1"
                                                style={{
                                                    fontSize: '18px',
                                                    fontWeight: 'bold',

                                                    marginRight: '20px',// Adding margin between label and value
                                                }}
                                            >
                                                Service&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; :
                                            </Typography>
                                            <Typography
                                                variant="subtitle1"
                                                style={{
                                                    fontSize: '18px',

                                                    fontWeight: 'normal',
                                                }}
                                            >
                                                {service.label}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} md={12} style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
                                            {/* Service */}
                                            <Typography
                                                variant="subtitle1"
                                                style={{
                                                    fontSize: '18px',
                                                    fontWeight: 'bold',

                                                    marginRight: '20px',// Adding margin between label and value
                                                }}
                                            >
                                                Year&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; :
                                            </Typography>
                                            <Typography
                                                variant="subtitle1"
                                                sx={{
                                                    fontSize: '18px',
                                                    fontWeight: 'normal',
                                                }}
                                            >
                                                {currentyear}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>


                            <TableHead style={{ border: "1px solid black" }}>
                                <TableRow >
                                    <TableCell sx={{ fontWeight: "bold", color: "black", padding: '4px', border: "1px solid black", textAlign: "center", }} rowSpan={2}>No</TableCell>
                                    {level === 0 && (
                                        <TableCell
                                            sx={{
                                                fontWeight: 'bold',
                                                color: 'black',
                                                padding: '8px',
                                                border: '1px solid black',
                                                textAlign: 'center',
                                            }}
                                            rowSpan={2}
                                        >
                                            Hospital
                                        </TableCell>
                                    )}

                                    {/* <TableCell sx={{ fontWeight: "bold", color: "black", padding: '4px', border: "1px solid black", textAlign: "center", }} rowSpan={2}>Company</TableCell> */}
                                    <TableCell sx={{ fontWeight: "bold", color: "black", padding: '4px', border: "1px solid black", textAlign: "center", }} rowSpan={2}>Status</TableCell>
                                    <TableCell sx={{ fontWeight: "bold", color: "black", padding: '4px', border: "1px solid black", textAlign: "center", }} rowSpan={2}>License Number</TableCell>
                                    {licensecategory.value === 0 && (<>
                                        <TableCell sx={{ fontWeight: "bold", color: "black", padding: '4px', border: "1px solid black", textAlign: "center", }} rowSpan={2}>Asset Numbers</TableCell>
                                        <TableCell sx={{ fontWeight: "bold", color: "black", padding: '4px', border: "1px solid black", textAlign: "center", }} rowSpan={2}>Equipment / System Description</TableCell>
                                        <TableCell sx={{ fontWeight: "bold", color: "black", padding: '4px', border: "1px solid black", textAlign: "center", }} rowSpan={2}>Serial Number</TableCell>
                                        <TableCell sx={{ fontWeight: "bold", color: "black", padding: '4px', border: "1px solid black", textAlign: "center", }} rowSpan={2}>Model</TableCell>
                                        <TableCell sx={{ fontWeight: "bold", color: "black", padding: '4px', border: "1px solid black", textAlign: "center", }} rowSpan={2}>Vendor Name</TableCell>
                                        <TableCell sx={{ fontWeight: "bold", color: "black", padding: '4px', border: "1px solid black", textAlign: "center", }} rowSpan={2}>vendor Code</TableCell>
                                        <TableCell sx={{ fontWeight: "bold", color: "black", padding: '4px', border: "1px solid black", textAlign: "center", }} rowSpan={2}>Employee Name</TableCell>
                                        <TableCell sx={{ fontWeight: "bold", color: "black", padding: '4px', border: "1px solid black", textAlign: "center", }} rowSpan={2}>Employee Code</TableCell>
                                    </>
                                    )}
                                    {licensecategory.value === 1 && (<>
                                        <TableCell sx={{ fontWeight: "bold", color: "black", padding: '4px', border: "1px solid black", textAlign: "center", }} rowSpan={2}>Asset Numbers</TableCell>
                                        <TableCell sx={{ fontWeight: "bold", color: "black", padding: '4px', border: "1px solid black", textAlign: "center", }} rowSpan={2}>Equipment / System Description</TableCell>
                                        <TableCell sx={{ fontWeight: "bold", color: "black", padding: '4px', border: "1px solid black", textAlign: "center", }} rowSpan={2}>Serial Number</TableCell>
                                        <TableCell sx={{ fontWeight: "bold", color: "black", padding: '4px', border: "1px solid black", textAlign: "center", }} rowSpan={2}>Model</TableCell>
                                    </>
                                    )}
                                    {licensecategory.value === 2 && (<>
                                        <TableCell sx={{ fontWeight: "bold", color: "black", padding: '4px', border: "1px solid black", textAlign: "center", }} rowSpan={2}>Vendor Name</TableCell>
                                        <TableCell sx={{ fontWeight: "bold", color: "black", padding: '4px', border: "1px solid black", textAlign: "center", }} rowSpan={2}>vendor Code</TableCell>
                                    </>
                                    )}
                                    {licensecategory.value === 3 && (<>
                                        <TableCell sx={{ fontWeight: "bold", color: "black", padding: '4px', border: "1px solid black", textAlign: "center", }} rowSpan={2}>Employee Name</TableCell>
                                        <TableCell sx={{ fontWeight: "bold", color: "black", padding: '4px', border: "1px solid black", textAlign: "center", }} rowSpan={2}>Employee Code</TableCell>
                                    </>
                                    )}
                                    <TableCell sx={{ fontWeight: "bold", color: "black", padding: '4px', border: "1px solid black", textAlign: "center", }} rowSpan={2}>License Category</TableCell>
                                    <TableCell sx={{ fontWeight: "bold", color: "black", padding: '4px', border: "1px solid black", textAlign: "center", }} rowSpan={2}>License Type Code</TableCell>
                                    <TableCell sx={{ fontWeight: "bold", color: "black", padding: '4px', border: "1px solid black", textAlign: "center", }} rowSpan={2}>Next Inspection Date</TableCell>
                                    <TableCell sx={{ fontWeight: "bold", color: "black", padding: '4px', border: "1px solid black", textAlign: "center", }} rowSpan={2}>Expiry Date</TableCell>
                                    <TableCell sx={{ fontWeight: "bold", color: "black", padding: '4px', border: "1px solid black", textAlign: "center", }} rowSpan={2}>Issue Date</TableCell>
                                    <TableCell sx={{ fontWeight: "bold", color: "black", padding: '4px', border: "1px solid black", textAlign: "center", }} rowSpan={2}>Remarks</TableCell>

                                </TableRow>

                            </TableHead>
                            <TableBody style={{ border: "1px solid black" }}>
                                {reportdata.length > 0 ? (
                                    reportdata.map((row, rowIndex) => {

                                            return (
                                                <TableRow key={rowIndex}>
                                                    <TableCell sx={{ padding: '4px', border: "1px solid black" }}>{rowIndex + 1}</TableCell>
                                                    {level === 0 && (<TableCell sx={{ padding: '4px', border: "1px solid black" }}>{row.hospital}</TableCell>)}
                                                    {/* <TableCell sx={{ padding: '4px', border: "1px solid black" }}>{row.companyName || ''}</TableCell> */}
                                                    <TableCell align="right" sx={{ padding: '4px', border: "1px solid black" }}>{row.licensestatus || ''}</TableCell>
                                                    <TableCell sx={{ padding: '4px', border: "1px solid black" }}>{row.licenseno || ''}</TableCell>
                                                    {licensecategory.value === 0 && (<>
                                                        <TableCell sx={{ padding: '4px', border: "1px solid black" }}>{row.assetno || ''}</TableCell>
                                                        <TableCell sx={{ padding: '4px', border: "1px solid black" }}>{row.assetdesc || ''}</TableCell>
                                                        <TableCell sx={{ padding: '4px', border: "1px solid black" }}>{row.serialno || ''}</TableCell>
                                                        <TableCell sx={{ padding: '4px', border: "1px solid black" }}>{row.model || ''}</TableCell>
                                                        <TableCell sx={{ padding: '4px', border: "1px solid black" }}>{row.vendorname || ''}</TableCell>
                                                        <TableCell sx={{ padding: '4px', border: "1px solid black" }}>{row.vendorcode || ''}</TableCell>
                                                        <TableCell sx={{ padding: '4px', border: "1px solid black" }}>{row.employeename || ''}</TableCell>
                                                        <TableCell sx={{ padding: '4px', border: "1px solid black" }}>{row.employeecode || ''}</TableCell>
                                                    </>)}
                                                    {licensecategory.value === 1 && (<>
                                                        <TableCell sx={{ padding: '4px', border: "1px solid black" }}>{row.assetno || ''}</TableCell>
                                                        <TableCell sx={{ padding: '4px', border: "1px solid black" }}>{row.assetdesc || ''}</TableCell>
                                                        <TableCell sx={{ padding: '4px', border: "1px solid black" }}>{row.serialno || ''}</TableCell>
                                                        <TableCell sx={{ padding: '4px', border: "1px solid black" }}>{row.model || ''}</TableCell>
                                                    </>)}
                                                    {licensecategory.value === 2 && (<>
                                                        <TableCell sx={{ padding: '4px', border: "1px solid black" }}>{row.vendorname || ''}</TableCell>
                                                        <TableCell sx={{ padding: '4px', border: "1px solid black" }}>{row.vendorcode || ''}</TableCell>
                                                    </>)}
                                                    {licensecategory.value === 3 && (<>
                                                        <TableCell sx={{ padding: '4px', border: "1px solid black" }}>{row.employeename || ''}</TableCell>
                                                        <TableCell sx={{ padding: '4px', border: "1px solid black" }}>{row.employeecode || ''}</TableCell>
                                                    </>)}
                                                    <TableCell sx={{ padding: '4px', border: "1px solid black" }}>{row.licensecategory || ''}</TableCell>
                                                    <TableCell sx={{ padding: '4px', border: "1px solid black" }}>{row.licensetypecode || ''}</TableCell>
                                                    <TableCell sx={{ padding: '4px', border: "1px solid black" }}>{row.nextinspectiondate || ''}</TableCell>
                                                    <TableCell sx={{ padding: '4px', border: "1px solid black" }}>{row.expirydate || ''}</TableCell>
                                                    <TableCell sx={{ padding: '4px', border: "1px solid black" }}>{row.issuedate || ''}</TableCell>
                                                    <TableCell sx={{ padding: '4px', border: "1px solid black" }}>{row.remarks || ''}</TableCell>

                                                </TableRow>
                                            );
                                        })
                                ) : (
                                    <TableRow>
                                        <TableCell colSpan={19} align="center">No data available</TableCell>
                                    </TableRow>
                                )}
                            </TableBody>


                        </div>
                    </TableContainer>
                </div>
            </div>
        </>
    );
};

export default Licensedetails;
